/* src/modules/dashboard/components/PieChart/styles.js */

export default theme => ({
  container: {
    padding: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'center'
  },
  title: {
    marginBottom: theme.spacing.unit * 2,
  },
});



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/PieChart/styles.js